<div id="imgHome"></div>
<div id="bannerHome" class="border-bottom">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-7">
                <h3>
                    <img src="/assets/images/cvd_logo.png" alt="CVDPREVENT logo" id="imgLogo" width="500" height="120" fetchpriority="high" decoding="async">
                </h3>
                <h1 class="header-text display-4 fw-bold">
                    Data & Improvement Tool<span class="beta">beta</span>
                </h1>
                <p class="lead">
                    The Cardiovascular Disease Prevention Audit (CVDPREVENT) is a national primary care audit that automatically extracts routinely held GP data. This tool provides open access to the data, with clear, actionable insights for those tasked with improving cardiovascular health in England.
                </p>
                <div>
                    <button class="btn btn-lg btn-primary video-button" (click)="toggleVideo(true)">
                        <i class="fas fa-play-circle me-2"></i>
                        Watch the demonstration video
                    </button>
                    <small class="text-muted scroll-down">
                        or scroll down to start <i class="fas fa-caret-down"></i>
                    </small>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="videoContainer" *ngIf="videoOpen">
    <button type="button" class="btn-close btn-close-white float-end mb-2" aria-label="Close" (click)="toggleVideo(false)"></button>
    <iframe width="100%" height="90%" [src]="videoUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>

<div class="container mt-lg">
    <div class="row justify-content-start">
        <div class="col-12 mb-3">
            <h2 class="fw-bold">Explore. Understand. Improve.</h2>
            <p class="lead">All the tools you need to take action.</p>
        </div>
        <div class="col-lg-6 mt-3">
            <div class="card">
                <div class="card-body">
                    <h1 class="text-dark">
                        <i class="far fa-file-chart-line"></i>
                    </h1>
                    <h5 class="card-title">
                        Insights
                    </h5>
                    <p class="card-text">
                        Every indicator for your Region, ICB, Sub-ICB, PCN or Practice, with inequality markers, trends and comparisons.
                    </p>
                    <a [routerLink]="['/insights']" class="btn btn-primary">
                        See the indicators<i class="fas fa-caret-right ms-2"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-lg-6 mt-3">
            <div class="card">
                <div class="card-body">
                    <h1 class="text-dark">
                        <i class="far fa-shield-check"></i>
                    </h1>
                    <h5 class="card-title">
                        Outcomes&nbsp;<small><sup><span class="beta">experimental</span></sup></small>
                    </h5>
                    <p class="card-text">
                        Investigate the health outcomes of CVDPREVENT audit patients.
                    </p>
                    <a [routerLink]="['/outcomes-intro']" class="btn btn-primary">
                        Review Outcomes<i class="fas fa-caret-right ms-2"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="bg-white py-5 mt-lg border-top border-bottom">
    <div class="container">
        <div class="row justify-content-start">
            <div class="col-12 mb-3 text-center">
                <h2 class="fw-bold">Take the data further.</h2>
                <p class="lead">Use the data in your own dashboards.</p>
            </div>
            <div class="col-lg-4 mt-3 text-center">
                <h1 class="text-dark">
                    <i class="far fa-file-download"></i>
                </h1>
                <h5 class="card-title">
                    Data Extracts
                </h5>
                <p class="card-text">
                    Download the raw data for each of the indicators at any system level.
                </p>
                <a [routerLink]="['/data-extract']" class="btn btn-outline-primary">
                    Specify your download
                </a>
            </div>
            <div class="col-lg-4 mt-3 text-center">
                <h1 class="text-dark">
                    <i class="far fa-code"></i>
                </h1>
                <h5 class="card-title">
                    API
                </h5>
                <p class="card-text">
                    Read more about how to access the data directly via our custom API.
                </p>
                <a href="https://bmchealthdocs.atlassian.net/wiki/spaces/CP/pages/317882369/CVDPREVENT+API+Documentation" target="_blank" class="btn btn-outline-primary">
                    Go to documentation
                </a>
            </div>
            <div class="col-lg-4 mt-3 text-center">    
                <h1 class="text-dark">
                    <i class="far fa-books"></i>
                </h1>
                <h5 class="card-title">
                    Additional Resources
                </h5>
                <p class="card-text">
                    Links to additional tools, reports and data aimed at supporting real-world change.
                </p>
                <a [routerLink]="['/resources']" class="btn btn-outline-primary">
                    Explore all resources
                </a>
            </div>
        </div>
    </div>
</div>

<div class="py-5">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-12">
                <h2 class="fw-bold">About CVDPREVENT</h2>
                <p class="lead">Learn more about the audit's aims and objectives.</p>
            </div>
            <div class="col-md-6 col-12">
                <p>
                    CVDPREVENT is a national audit of GP records to support primary care in understanding how many people with cardiovascular disease (CVD), or conditions that lead to a higher risk of developing CVD, are potentially undiagnosed, under treated or over treated. Analysis and reporting of the audit is designed to support systematic quality improvement using the findings from annual audit reports and the associated Data & Improvement Tool, to reduce health inequalities and improve outcomes for individuals and populations.
                </p>
                <p>
                    This Data & Improvement Tool enables you to drill down into the data, showing information at National, ICS, PCN and individual practice levels to enable teams to understand the performance of their services and potential improvement opportunities.
                </p>
                <!-- <p>
                    <a href="https://static1.squarespace.com/static/58d8d0ffe4fcb5ad94cde63e/t/64085d3500160d31429d6d0d/1678269749467/CVDP+DIT+data+publication+dates.png" target="_blank">
                        <strong>Upcoming Quarterly Data Publication Dates</strong>
                    </a>
                </p> -->
                <p>
                    <a href="https://static1.squarespace.com/static/65eafc36395e4d64e18a3232/t/6937fb8666a6d23761182c05/1765276550824/CVDPREVENT+Fifth+Annual+Report.pdf" target="_blank">
                        The latest <strong>CVDPREVENT Annual Audit Report</strong> can be accessed here, along with all past reports.
                    </a>
                </p>
            </div>
            <div class="col-md-6 col-12">
                <p>
                    The “resources for next steps” page signposts teams to tools and approaches to support their quality improvement journey.
                </p>
                <p>
                    In addition to the Annual Audit Reports and Data & Improvement Tool, pilot sites will work with the CVDPREVENT team to share their experiences of using the data, applying improvement approaches, developing case studies and blogs, and monitoring progress, to help others learn from their work. The initial pilot sites are <strong>Cheshire and Mersey Health and Care Partnership</strong> and <strong>Kent Surrey Sussex Academic Health Science Network (KSS AHSN)</strong>.
                </p>
            </div>          
        </div>
    </div>
</div>